import { getOneButtonCapabilityValue } from '../../../../services/oneButtonServices/capabilityService';
import type { OneButtonUserCapabilityResponse } from '../../../../@types/oneButtonCapability';

/**
 * V1 `EnableManualMode()` in Trinity-One-Button-UI
 * `system-design.component.ts`. The solar product's Finance_Partner is mapped to a
 * UAM capability. The toggle is shown only when that capability value is exactly `View`.
 */
const SOLAR_PRODUCT = 'Solar';

const MANUAL_MODE_CAPABILITY_BY_PARTNER: Record<string, string> = {
    'Good Leap': 'SystemDesign_Manual_GoodLeap',
    Lightreach: 'SystemDesign_Manual_Lightreach',
    Sunnova: 'SystemDesign_Manual_Sunnova',
    IGS: 'SystemDesign_Manual_IGS',
    Cash: 'SystemDesign_Manual_cash',
    Sunlight: 'SystemDesign_Manual_Sunlight',
};

/** V1 `environment.disabledFinancePartnersOfArrayOverride` (IGS in every environment). */
const ARRAY_OVERRIDE_DISABLED_PARTNERS = ['IGS'];

export function enableManualMode(
    systemDesign: { OpportunityProductsFinanceInfo?: Array<Record<string, unknown>> } | null | undefined,
    capabilities: OneButtonUserCapabilityResponse | null | undefined,
): boolean {
    const products = systemDesign?.OpportunityProductsFinanceInfo;
    if (!Array.isArray(products)) return false;

    return products.some((ele) => {
        if (ele?.Product_Type_Name !== SOLAR_PRODUCT) return false;
        const partner = String(ele.Finance_Partner ?? '');
        const capabilityName = MANUAL_MODE_CAPABILITY_BY_PARTNER[partner];
        if (!capabilityName) return false;
        return getOneButtonCapabilityValue(capabilities, capabilityName) === 'View';
    });
}

/** V1 `checkEnableOverride()` — hides the Arrays Override switch for partners in the environment list. */
export function enableArrayOverride(
    systemDesign: { OpportunityProductsFinanceInfo?: Array<Record<string, unknown>> } | null | undefined,
): boolean {
    const products = systemDesign?.OpportunityProductsFinanceInfo;
    if (!Array.isArray(products)) return false;
    const solar = products.find((ele) => ele?.Product_Type_Name === SOLAR_PRODUCT);
    if (!solar) return false;
    const partner = String(solar.Finance_Partner ?? '');
    return !ARRAY_OVERRIDE_DISABLED_PARTNERS.includes(partner);
}

export function solarFinancePartnerId(
    systemDesign: { OpportunityProductsFinanceInfo?: Array<Record<string, unknown>> } | null | undefined,
): number | null {
    const products = systemDesign?.OpportunityProductsFinanceInfo;
    if (!Array.isArray(products)) return null;
    const solar = products.find((ele) => ele?.Product_Type_Name === SOLAR_PRODUCT);
    const id = Number(solar?.Finance_Partner_Id);
    return Number.isFinite(id) && id > 0 ? id : null;
}
